import React from 'react';
import {Alert, Button, Skeleton} from "antd";
import {useQuery} from 'react-query';
import {useParams, useNavigate } from "react-router-dom";
import {GetApp} from "../../../../../api/apps";
import {AppHeader} from '../../../app/Header';


export const AppController = (props) => {
    const params = useParams();

    const { developer_id, app_id } = params;
    const nav = useNavigate();

    const App = useQuery(
        ['app', params.developer_id, params.app_id],
        () => GetApp(params.developer_id, params.app_id)
    );

    const StoreApp = App?.data?.app || {};


    return (
        <div className={`dev__layout app`}>
            {App.isLoading && <Skeleton rows={12}/>}
            {App.isLoading === false && (
                <>
                    <AppHeader {...StoreApp} />
                    {(StoreApp?.description === '') && (
                        <div className={`alerts--block`}>
                            <Alert
                                type={`warning`}
                                message={`У вашего приложения еще не полность заполнено описание. Пожалуйста заполните его перед отправкой на публикацию`}
                                action={<Button type={`link`} onClick={() => nav(`/console/${developer_id}/app/${app_id}/store`)}>Заполнить</Button>}
                            />
                        </div>
                    )}
                    <AppNotifications/>
                    <AppStats/>
                </>
            )}
        </div>
    );
}

const AppNotifications = (props) => {
    return (
        <div className={`app--block app--block__notificatons`}>
            <h2>Уведомления</h2>
            <div className="app--block__wrapper">
                <div className={`in_progress`}>На этапе разработки</div>
            </div>
        </div>
    );
}


const AppStats = (props) => {
    return (
        <div className={`app--block app--block__notifications`}>
            <h2>Статистика</h2>
            <div className="app--block__wrapper">
                <div className={`in_progress`}>На этапе разработки</div>
            </div>
        </div>
    );
}


export default AppController;